'use strict';

import Loading from '~/components/Loading';

const PhoneInput = React.lazy(() => import('~/components/PhoneInput'));

export default function AuthLoginForm({
    phone,
    phoneCode,
    phoneComplete,
    errors,
    onPhoneChange,
    onCodeChange,
    onCompleteChange,
    onLogin,
    onGoSelect,
    primaryKey,
    secondaryKey,
    separatorKey,
}) {
    return (
        <div>
            <div className="reg-modal__title">
                {__('[Login] Title')}
            </div>
            <div className="reg-modal__row">
                <React.Suspense fallback={<Loading active={true} />}>
                    <PhoneInput
                        className={'reg-input'}
                        label={__('[Login] Phone')}
                        value={phone}
                        phoneCode={phoneCode}
                        error={errors.phone}
                        autoFocus={true}
                        onChange={(phoneValue) => onPhoneChange(phoneValue)}
                        onCodeChange={onCodeChange}
                        onCompleteChange={onCompleteChange}
                    />
                </React.Suspense>
            </div>
            <div className="reg-modal__btns">
                <button className={cn('button button-round', !phoneComplete && 'disabled')} onClick={onLogin}>
                    {__(primaryKey)}
                </button>
                {separatorKey && <div className="reg-modal__separator">
                    <span>{__(separatorKey)}</span>
                </div>}
            </div>
            <a className="button button-round-white" onClick={() => {
                onGoSelect();
                ymReachGoal('sign_up');
            }}>
                {__(secondaryKey)}
            </a>
        </div>
    );
}
